"use strict";
const logoutButton = document.querySelector('.logout-link');
const plattformLink = process.env.SERVICEPLATTFORM_URL;
if (logoutButton) {
    logoutButton.addEventListener('click', () => {
        window.location.assign(plattformLink);
    });
}
if (window.location.search === '?logintype=logout') {
    window.addEventListener('load', () => {
        window.location.assign(plattformLink);
    });
}
